import React, { useState } from 'react';
import SelectionBox from './SelectionBox';
import AnalyticsBox from './AnalyticsBox';
import Card from '~/components/Card/Card';
import * as reportObj from '~/pages/Dashboard/AnalyticsBox/reports';

function Dashboard() {
    const reports = Object.keys(reportObj);
    const [selectedReport, setSelectedReport] = useState(reports[0]);

    return (
        <>
            <Card>
                <SelectionBox
                    setSelectedReport={setSelectedReport}
                    reports={reports}
                />
            </Card>
            <AnalyticsBox
                selectedReport={selectedReport}
                reportObj={reportObj}
            />
        </>
    );
}

export default Dashboard;
